const rootEl = document.querySelector(":root") as HTMLElement

export const setCssVar = (cssVar: string, newVal: string) => {
  rootEl.style.setProperty(cssVar, newVal)
}

export const getCssVar = (cssVar: string) => {
  return getComputedStyle(rootEl).getPropertyValue(cssVar)
}
